module.exports = __webpack_public_path__ + "img/14.acad540d.png";